import Vue from 'vue'
import Router from 'vue-router'
import orderSong from '@/pages/orderSong'
import daily from '@/pages/daily'
import songDetail from '@/pages/songDetail'
import createComment from '@/pages/createComment'
import monthly from '@/pages/monthly'
import admin from '@/pages/admin'
import login from '@/pages/login'
import random from '@/pages/random'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'orderSong',
      component: orderSong
    },
    {
      path: '/daily',
      name: 'daily',
      component: daily
    },
    {
      path: '/songDetail',
      name: 'songDetail',
      component: songDetail
    },
    {
      path: '/createComment',
      name: 'createComment',
      component: createComment
    },
    {
      path: '/monthly',
      name: 'monthly',
      component: monthly
    },
    {
      path: '/admin',
      name: 'admin',
      component: admin
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/random',
      name: 'random',
      component: random
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js